// /src/ui/layout/Footer.tsx

type FooterProps = {
  brandName: string;
  fullWidth?: boolean;
};

export function Footer({ brandName, fullWidth }: FooterProps) {
  return (
    <footer className="border-t border-border">
      <div className={`${fullWidth ? 'w-full' : 'mx-auto max-w-6xl'} px-4 pt-3 text-xs text-muted`}>
        © {new Date().getFullYear()} Bushin Consulting — {brandName}™ built on Context™ platform
      </div>
      <div className={`${fullWidth ? 'w-full' : 'mx-auto max-w-6xl'} px-4 py-2 text-xs text-muted`}>
        Book covers and titles are shown for identification and educational reference only.
        All rights remain with the respective authors and publishers.
        This platform is not affiliated with or endorsed by them.
      </div>
    </footer>
  );
}
